<template>
  <el-drawer
    custom-class="drawer"
    title="更新日志"
    :modelValue="modelValue"
    @update:modelValue="emit('update:modelValue', $event)"
    size="700"
  >
    <div v-infinite-scroll="scrollHandle">
      <el-table
        ref="table"
        :data="responseFields.tableData"
        highlight-current-row
        style="width: 100%"
        :header-cell-style="cellStyle"
        :cell-style="cellStyle"
        v-loading="loading"
        :row-key="(row) => row.id"
        :expand-row-keys="responseFields.expand"
        @expand-change="expandChange"
        @row-click="rowClick"
      >
        <el-table-column type="expand">
          <template #default="{ row }">
            <div v-html="row.content"></div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="80" />
        <el-table-column prop="title" label="标题" />
        <el-table-column prop="look" label="状态" width="80">
          <template #default="{ row }">
            <div v-if="row.look === 1">已读</div>
            <div v-else>未读</div>
          </template>
        </el-table-column>
        <el-table-column prop="create_timeFormat" label="时间" width="180" />
      </el-table>
    </div>
  </el-drawer>
</template>

<script setup>
import { toRefs, reactive, watchEffect, nextTick } from 'vue'
import { useStore } from 'vuex'
import { article_list, article_look } from '@/utils/api'

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const { modelValue } = toRefs(props)

const requestFields = reactive({
  page: 1,
  limit: 20,
  refresh: Date.now(),
})
const responseFields = reactive({
  tableData: [],
  total: 1,
  expand: [],
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  modelValue.value &&
    article_list(requestFields, {
      signal: controller.signal,
    }).then(({ data: res }) => {
      responseFields.tableData.push(...res.data)
      responseFields.total = res.count
    })
  onInvalidate(() => {
    controller.abort()
  })
})

const cellStyle = ({ column }) => {
  let style = {
    textAlign: 'center',
  }
  if (column.property === 'title') {
    style['textAlign'] = 'left'
  }
  return style
}

const expandChange = (row) => {
  if (row.look === 0) {
    article_look({
      id: row.id,
    }).then(() => {
      row.look = 1
      responseFields.expand = [row.id]
    })
  }
}

const scrollHandle = () => {
  if (
    !loading.value &&
    responseFields.tableData.length < responseFields.total
  ) {
    requestFields.page++
  }
}

const rowClick = async (row) => {
  if (row.look === 0) {
    await article_look({
      id: row.id,
    })
    row.look = 1
  }
  responseFields.expand = [row.id]
}
</script>
